import { render, staticRenderFns } from "./Arranged.vue?vue&type=template&id=6ed744ba"
import script from "./Arranged.vue?vue&type=script&lang=js"
export * from "./Arranged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports